<template>
  <v-dialog v-model="show" width="500px">
    <v-card>
      <v-card-title class="status-history-title">{{ title }}</v-card-title>
      <v-card-text>
        <v-timeline dense>
          <v-timeline-item v-for="(status, index) in history" v-bind:key="status._id || index">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>
                  <!-- Presentation-only: each caller supplies label/colors via resolver props. A caller
                         needing a different status representation can override this slot without a refactor. -->
                  <slot name="status" :entry="status">
                    <v-chip
                      small
                      :color="getBgColor ? getBgColor(status.label_status) : undefined"
                      :text-color="getTextColor ? getTextColor(status.label_status) : undefined"
                    >
                      {{ getLabel(status.label_status) }}
                    </v-chip>
                  </slot>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ new Date(status.date) | moment('DD/MM/YYYY HH:mm:ss') }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="status.username">
                  {{ $t('user.username') }}: {{ status.username }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="status.email">
                  {{ $t('user.email') }} : {{ status.email }}
                </v-list-item-subtitle>
                <v-list-item-subtitle class="text-wrap" v-if="status.status_comment">
                  {{ $t('components.modalHistory.comment') }} : {{ status.status_comment }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-timeline-item>
        </v-timeline>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-btn color="secondary" tile block @click="close">{{ $t('subOrder.return') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /**
   * Generic, presentation-only status-history timeline dialog. It renders the parts that are the same
   * across every domain (date, author, email, comment) and delegates the domain-specific status pill to
   * resolver props (or the `status` scoped slot). It holds no hardcoded status/label maps, so it can be
   * reused for refunds, transactions, and — later — orders/returns, each passing its own resolvers.
   */
  export default {
    name: 'StatusHistoryTimeline',
    props: {
      // v-model visibility.
      value: {
        required: true,
      },
      // The status_history entries to display ({ label_status, date, status_comment, username, email }).
      history: {
        type: Array,
        default: () => [],
      },
      // Dialog title.
      title: {
        type: String,
        default: '',
      },
      // Resolves an entry's label_status to a translated label. Required.
      getLabel: {
        type: Function,
        required: true,
      },
      // Optional: resolves an entry's label_status to a Vuetify background color class for the chip.
      getBgColor: {
        type: Function,
        default: null,
      },
      // Optional: resolves an entry's label_status to a Vuetify text color class for the chip.
      getTextColor: {
        type: Function,
        default: null,
      },
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
    methods: {
      close: function () {
        this.$emit('input', false)
        this.$emit('close')
      },
    },
  }
</script>

<style scoped>
  /* Vuetify's .v-card__title defaults to word-break: break-all, which splits a long title
     mid-word. Wrap between words instead and keep the title centered. */
  .status-history-title {
    justify-content: center;
    text-align: center;
    word-break: normal;
  }
</style>
